import {
  ExplorePoolsWapper,
  LiquidityContainer,
  LiquidityWrapper,
  ExplorePoolHeader,
} from "../Liquidity/styled";
import { useContext, useEffect, useState } from "react";
import KeyvisualCommon from "../../../components/Common/Keyvisual";
import { ContextProviderWrapper } from "../../../components/Context";
import IDOLaunch from "./IDO";
import { LaunchpadWapper } from "./styled";
import TabsSelector from "../Farm/TabsSelector";
import EndedLaunchpad from "./Ended";
import UpComing from "./Coming";
import { AVAX_API } from "../../../services/api/indexV2";
import _ from "lodash";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const Liquidity = () => {
  const [activeTab, setActiveTab] = useState(3);
  const [data, setData]: any = useState();
  const [finishedData, setFinishedData]: any = useState([]);
  const { isMobile, theme } = useContext(ContextProviderWrapper)!;
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const TabsTitle = [
    {
      title: "On Live",
      value: 1,
      label: `${data?.length > 0 ? data?.length : 0}`,
    },
    {
      title: `${isMobile ? "Coming" : "Up Coming"}`,
      value: 2,
      label: `0`,
    },
    {
      title: "Ended",
      value: 3,
      label: `${finishedData?.length > 0 ? finishedData.length : 0}`,
    },
  ];

  const handleGetPool = async () => {
    try {
      const { data } = await AVAX_API.getPools();
      const dataSortByDate = _.orderBy(data, "start_date");
      const dataIDO = _.orderBy(dataSortByDate, "start_date").map(
        (item: any, index: number) => {
          return {
            ...item,
            name: dataSortByDate[index]?.round_name,
            describe: dataSortByDate[index]?.description,
            total_saled: dataSortByDate[index]?.total_saled_usd,
            total_raise: dataSortByDate[index]?.total_raise_usd,
            start_date: dayjs(dataSortByDate[index]?.start_date),
            rate: dataSortByDate[index]?.price_usd,
            end_date: dayjs(dataSortByDate[index]?.end_date),
            id: dataSortByDate[index]?.id,
            banner: dataSortByDate[index]?.image,
          };
        }
      );

      const finishedPools = dataIDO.filter(
        (item: any) =>
          item.end_date.isBefore(dayjs()) || item.end_date.isSame(dayjs())
      );

      const activePools = dataIDO.filter((item: any) =>
        item.end_date.isAfter(dayjs())
      );

      setFinishedData(finishedPools);
      setData(activePools);
    } catch (error) {
      console.log("view detail", error);
    }
  };

  useEffect(() => {
    handleGetPool();
    const intervalGetPool = setInterval(() => {
      handleGetPool();
    }, 5000);
    return () => {
      clearInterval(intervalGetPool);
    };
  }, []);

  const handleClaimReward = async (data: any) => {
    try {
      navigate(`/launchpad/avax/${data.id}`);
    } catch (error) {
      console.log("view detai", error);
    }
  };

  const handleChangeTabs = () => {
    switch (activeTab) {
      case 1:
        return <IDOLaunch data={data} handleClaimReward={handleClaimReward} />;
      case 2:
        return <UpComing />;
      case 3:
        return (
          <EndedLaunchpad
            finishedData={finishedData}
            handleClaimReward={handleClaimReward}
          />
        );
    }
  };

  return (
    <LaunchpadWapper className={theme}>
      <LiquidityContainer>
        <KeyvisualCommon
          title="Kibble launchpad"
          description={
            isMobile
              ? "Exclusive support for the \nlaunch of base-AVAX projects"
              : "Exclusive support for the launch of base-AVAX projects"
          }
          image={""}
          buttonText="Launch your project"
          buttonLink="/launchpad/form"
          buttonIcon={""}
        />
        <LiquidityWrapper>
          <ExplorePoolsWapper>
            <ExplorePoolHeader>
              {!isMobile && (
                <h1>
                  EXPLORE POOLS
                  <span className={theme}>3</span>
                </h1>
              )}
              <TabsSelector
                data={TabsTitle}
                callBack={(data: any) => {
                  setActiveTab(data.value);
                }}
                active={activeTab}
              />
            </ExplorePoolHeader>
            <div
              style={{
                marginTop: "20px",
              }}
            >
              {handleChangeTabs()}
            </div>
          </ExplorePoolsWapper>
        </LiquidityWrapper>
      </LiquidityContainer>
    </LaunchpadWapper>
  );
};

export default Liquidity;
